import React from "react";

const TitleConfig = ({title = 'Ahorro Seguro'}) => (
  <div className="titleConfig">
    <div className="titleConfig__container">
      <div className="titleConfig__container__t1">
        Configuración <span className='titleConfig__container__t1__name'>{title}</span>
      </div>
      <div className="titleConfig__container__t2">
        Estas son las opciones de configuración para {title}
      </div>
    </div>
  </div>
);

export default TitleConfig;